var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-config-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("instance.instance"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "instance" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c("div", { staticClass: "admin-config-panel__inner" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                  keydown: function ($event) {
                    return _vm.configForm.errors.clear($event.target.name)
                  },
                },
              },
              [
                _c(
                  "section",
                  {
                    staticClass: "admin-config-section",
                    attrs: { "aria-label": _vm.trans("instance.instance") },
                  },
                  [
                    _c("h4", { staticClass: "admin-config-section__title" }, [
                      _vm._v(_vm._s(_vm.trans("instance.instance"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "admin-config-section__description" },
                      [
                        _vm._v(
                          "Instance maintenance settings affect tenant access. Add an exclusion list before enabling maintenance when admins need continued access."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md-4 form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "configuration.instance_maintenance_mode"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("switches", {
                              attrs: {
                                name: "instance_maintenance_mode",
                                theme: "bootstrap",
                                color: "success",
                              },
                              model: {
                                value: _vm.configForm.instance_maintenance_mode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configForm,
                                    "instance_maintenance_mode",
                                    $$v
                                  )
                                },
                                expression:
                                  "configForm.instance_maintenance_mode",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.configForm.instance_maintenance_mode
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-4 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.instance_maintenance_mode_message"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  rows: "2",
                                  name: "instance_maintenance_mode_message",
                                  placeholder: _vm.trans(
                                    "configuration.instance_maintenance_mode_message"
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.configForm
                                      .instance_maintenance_mode_message,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.configForm,
                                      "instance_maintenance_mode_message",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "configForm.instance_maintenance_mode_message",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "instance_maintenance_mode_message",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.configForm.instance_maintenance_mode
                        ? _c(
                            "div",
                            { staticClass: "col-12 col-md-4 form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "configuration.instance_maintenance_exclude_ip"
                                      )
                                    ) + " "
                                  ),
                                  _c("show-tip", {
                                    attrs: {
                                      module: "configuration",
                                      tip: "tip_instance_maintenance_exclude_ip",
                                      type: "field",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  rows: "2",
                                  name: "instance_maintenance_exclude_ip",
                                  placeholder: _vm.trans(
                                    "configuration.instance_maintenance_exclude_ip"
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.configForm
                                      .instance_maintenance_exclude_ip,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.configForm,
                                      "instance_maintenance_exclude_ip",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "configForm.instance_maintenance_exclude_ip",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "instance_maintenance_exclude_ip",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "admin-config-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                      attrs: { type: "submit" },
                    },
                    [_vm._v(_vm._s(_vm.trans("general.save")))]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Control tenant instance maintenance messaging and access exceptions."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }